var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolicitationCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#28ABA1",
    stroke: "#B3FFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 27.3333H25.0002V23.3333H29.0002V21.3333H25.0002V17.3333H23.0002V21.3333H19.0002V23.3333H23.0002V27.3333ZM11.3335 37.0666V14.7333C11.3335 14.0666 11.5668 13.4999 12.0335 13.0333C12.5002 12.5666 13.0668 12.3333 13.7335 12.3333H34.2668C34.9335 12.3333 35.5002 12.5666 35.9668 13.0333C36.4335 13.4999 36.6668 14.0666 36.6668 14.7333V29.9333C36.6668 30.5999 36.4335 31.1666 35.9668 31.6333C35.5002 32.0999 34.9335 32.3333 34.2668 32.3333H16.0668L11.3335 37.0666ZM13.3335 32.2332L15.2335 30.3333H34.2668C34.3779 30.3333 34.4726 30.2941 34.5508 30.2159C34.6282 30.1386 34.6668 30.0444 34.6668 29.9333V14.7333C34.6668 14.6221 34.6282 14.5275 34.5508 14.4493C34.4726 14.3719 34.3779 14.3333 34.2668 14.3333H13.7335C13.6224 14.3333 13.5282 14.3719 13.4508 14.4493C13.3726 14.5275 13.3335 14.6221 13.3335 14.7333V32.2332ZM13.3335 14.7333V14.3333V32.2332V14.7333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitationCancel);
export default __webpack_public_path__ + "static/media/solicitation-cancel.641514b7.svg";
export { ForwardRef as ReactComponent };